import React from 'react';
import logo from "../assets/splash logo.svg";
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const Terms = () => {

    const navigate = useNavigate();

    const handleLinkClick = () => {
        navigate('/');
        window.scrollTo(0, 0);
    };

    return (
        <div className='flex bg-white flex-col lg:pl-[200px] ms:pl-[30px] pt-[80px] pb-[100px]'>
            <Helmet>
                <title>Swop | Terms & Conditions</title>
            </Helmet>
            <div className="fixed top-0 left-0 w-full bg-white shadow-md z-10 px-4 py-4 flex items-center">
                <Link to={'/'} onClick={handleLinkClick} className="flex items-center cursor-pointer">
                <img src={logo} alt="Swop Logo" className="w-[52.12px] h-[50px] lg:ml-[180px] sm:w-[40px] sm:h-[40px]" />
                <h1 className="uppercase text-spay-logo-text font-bold text-3xl sm:text-2xl ml-2">
                    Swop
                </h1>
                </Link>
            </div>
            <div className='text-[35px] mt-[50px] text-gray-900 font-bold'>
                Terms of Use
            </div>
            <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                By using this app (
                <span className='font-medium'>SWOP</span>
                ), any of our websites and/or services, you agree to these Terms of
                Use. The website Privacy Policy, Acceptable Use Policy and Merchant
                Terms of Service (where applicable) are incorporated by reference
                into these Terms of Use.
            </div>

            <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                Welcome to SWOP, a fintech mobile wallet app provided by SPay
                Business Solutions Limited. Please read these terms and conditions
                carefully before using our services.
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    1. Acceptance of Terms
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    By accessing or using the SWOP mobile wallet app ("the App"), you
                    agree to comply with and be bound by these Terms and Conditions. If
                    you do not agree with any part of these terms, you may not use the
                    App.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    2. User Registration
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    To use the App, you must register by providing accurate and complete
                    information. You agree to keep your password secure and
                    confidential. SPay Business Solutions Limited is not responsible for
                    any unauthorized access to your account.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    3. Information Collection
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    In order to provide you with our services, we collect the following
                    information:
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    - Full Name - Email Address - Phone Number - Home Address - Pictures
                    - Bank Verification Number (BVN) - Age - Gender
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    By using the App, you consent to the collection, storage, and
                    processing of your personal information as outlined in our Privacy
                    Policy.
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    Severability
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    If any portion of these Terms of Use is held by any court or
                    tribunal to be invalid or unenforceable, either in whole or in part,
                    then that part shall be severed from these Terms of Use and shall
                    not affect the validity or enforceability of any other part in this
                    Terms of Use.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    4. Use of Information
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    - Account verification and authentication - Transaction processing -
                    Customer support - Legal and regulatory compliance
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    5. Security
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    SPay Business Solutions Limited employs industry-standard security
                    measures to protect your personal information. However, you
                    acknowledge that no system is completely secure, and we cannot
                    guarantee the absolute security of your data.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    6.  Third-Party Logins
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    SWOP does not use third-party logins such as Google or Facebook.
                    User authentication is solely based on the password provided during
                    registration.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                7. Prohibited Activities
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    You agree not to engage in any prohibited activities, including but
                    not limited to fraud, money laundering, unauthorized access, and any
                    other activities that violate applicable laws and regulations.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    8. Know Your Customer
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    You agree that, you are solely responsible for verifying the
                    identities of your customers, ensuring that they are authorised to
                    carry out the transactions on your platform, and determining their
                    eligibility to purchase your products and services.
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    You are also required to maintain information and proof of service
                    or product delivery to your customer. Where a dispute occurs needing
                    resolution, you may be required to provide SPay with these.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                9. Card Network Rules
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    Each card network has its own rules, regulations and guidelines. You
                    are required to comply with all applicable Network Rules that are
                    applicable to merchants. You can review portions of the Network
                    Rules at Mastercard, Visa, Verve and other payment cards. The Card
                    Networks reserve the right to amend the Network Rules.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    10. Customer Payments
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    You may only process payments when authorised to do so by your
                    customer. We will only process transactions that have been
                    authorised by the applicable Card Network or card issuer.
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    We do not guarantee or assume any liability for transactions
                    authorised and completed that are later reversed or charged back
                    (see Chargebacks below). You are solely responsible for all reversed
                    or charged back transactions, regardless of the reason for, or
                    timing of, the reversal or chargeback. SPay may add or remove one or
                    more payment types or networks at any time. If we do so we will use
                    reasonable efforts to give you prior notice of the removal.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    11.  Our Fees &amp; Pricing Schedule
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    You agree to pay us for the services we render as a wallet mobile
                    app for your goods and services. Our Fees will be calculated as
                    demonstrated on the Pricing page on the website. The Fees on our
                    Pricing page is integral to and forms part of this Agreement.
                </div>
                <div className="mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]">
                    We reserve the right to revise our Fees. In the event that we revise
                    our fees we will notify you within 5 days of such change.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    12. Security and Fraud Controls
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    SPay is responsible for protecting the security of Payment Data
                    including CHD in our possession and will maintain commercially
                    reasonable administrative, technical, and physical procedures to
                    protect all the personal information regarding you and your
                    customers that is stored in our servers from unauthorised access and
                    accidental loss or modification. Although, we cannot guarantee that
                    unauthorised third parties will never be able to defeat those
                    measures or use such personal information for improper purposes. We
                    will however take all reasonable and commercially achievable
                    measures to address any security breach as soon as we become aware.
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    You agree to use other procedures and controls provided by us and
                    other measures that are appropriate for your business to reduce the
                    risk of fraud.
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    In the event that you suspect any fraudulent activity by a customer,
                    you agree to notify SPay immediately and quit the delivery of the
                    service. In addition, where we suspect that there have been frequent
                    fraudulent transactions on your account, we reserve the right to
                    cancel our service to you and/or your account
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    13. Notification of Errors
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    You agree to notify us immediately any error is detected while
                    reconciling transactions that have occurred using SPay. We will
                    investigate and rectify the errors where verified. In the event that
                    we notice any errors, we will also investigate and rectify such
                    errors.
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    Where we owe you money as a result of such errors, we will refund
                    the amounts owed to you by a bank transfer to your Bank Account.
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    If a transaction is erroneously processed through your platform,
                    report to us immediately. We will investigate any such reports and
                    attempt to rectify the errors by crediting or debiting your Bank
                    Account as appropriate.
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    Failure to notify us within 45 (forty-five) days of the occurrence
                    of an error will be deemed a waiver of your rights to amounts that
                    are owed to you due to an error.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    14. Termination
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    SPay Business Solutions Limited reserves the right to terminate or
                    suspend your account at any time without prior notice for violations
                    of these Terms and Conditions.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    15. Restricted Activities &amp; Acceptable Use Policy
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    You are independently responsible for complying with all applicable
                    laws related to your use of our website and services. However, by
                    accessing or using SPay, you agree to comply with the terms and
                    conditions of our Acceptable Use Policy and are restricted from the
                    activities specified in it which you can read on our Acceptable Use
                    Policy page.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    16. Privacy Policy
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    SPay is committed to managing your Personal Information in line with
                    global industry best practices. You can read our Privacy Policy to
                    understand how we use your information and the steps we take to
                    protect your information.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    17. Disclaimers
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    WE TRY TO KEEP SWOP AVAILABLE AT ALL TIMES, BUG-FREE AND SAFE,
                    HOWEVER, YOU USE IT AT YOUR OWN RISK.
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                OUR WEBSITE AND SERVICES ARE PROVIDED &ldquo;AS IS&rdquo; WITHOUT
            ANY EXPRESS, IMPLIED AND/OR STATUTORY WARRANTIES (INCLUDING, BUT NOT
            LIMITED TO, ANY IMPLIED OR STATUTORY WARRANTIES OF MERCHANTABILITY,
            FITNESS FOR A PARTICULAR USE OR PURPOSE, TITLE, AND NON-INFRINGEMENT
            OF INTELLECTUAL PROPERTY RIGHTS). WITHOUT LIMITING THE GENERALITY OF
            THE FOREGOING, SPay MAKES NO WARRANTY THAT OUR WEBSITE AND SERVICES
            WILL MEET YOUR REQUIREMENTS OR THAT OUR WEBSITE WILL BE
            UNINTERRUPTED, TIMELY, SECURE, OR ERROR FREE. NO ADVICE OR
            INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU THROUGH OUR
            WEBSITE OR FROM SPay, ITS PARENTS, SUBSIDIARIES, OR OTHER AFFILIATED
            COMPANIES, OR ITS OR THEIR SUPPLIERS (OR THE RESPECTIVE OFFICERS,
            DIRECTORS, EMPLOYEES, OR AGENTS OF ANY SUCH ENTITIES) (COLLECTIVELY,
            &quot;SPay PARTIES&quot;) SHALL CREATE ANY WARRANTY.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                18. Limitation of Liability
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                IN NO EVENT WILL ANY OF THE SPay PARTIES BE LIABLE FOR (A) ANY
            INDIRECT, SPECIAL, CONSEQUENTIAL, PUNITIVE, OR EXEMPLARY DAMAGES OR
            (B) ANY DAMAGES WHATSOEVER IN EXCESS OF THE AMOUNT OF THE
            TRANSACTION OR TWENTY THOUSAND UNITED STATES DOLLARS (US$20,000.00)
            DOLLARS, WHICHEVER IS LESSER (INCLUDING, WITHOUT LIMITATION, THOSE
            RESULTING FROM LOSS OF REVENUES, LOST PROFITS, LOSS OF GOODWILL,
            LOSS OF USE, BUSINESS INTERRUPTION, OR OTHER INTANGIBLE LOSSES),
            ARISING OUT OF OR IN CONNECTION WITH SPay&rsquo;S WEBSITE OR
            SERVICES (INCLUDING, WITHOUT LIMITATION, USE, INABILITY TO USE, OR
            THE RESULTS OF USE OF SPay&rsquo;S WEBSITES OR SERVICES), WHETHER
            SUCH DAMAGES ARE BASED ON WARRANTY, CONTRACT, TORT, STATUTE, OR ANY
            OTHER LEGAL THEORY.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    19. Exclusions
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                Some jurisdictions do not allow the exclusion of certain warranties
            or the limitation or exclusion of liability for certain damages.
            Accordingly, some of the above disclaimers and limitations of
            liability may not apply to you. To the extent that any SPay Party
            may not, as a matter of applicable law, disclaim any implied
            warranty or limit its liabilities, the scope and duration of such
            warranty and the extent of the SPay&rsquo;s Party&apos;s liability
            shall be the minimum permitted under such applicable law.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                20. Indemnity
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                You agree to defend, indemnify, and hold SPay, its officers,
            directors, employees, agents, licensors, and suppliers, harmless
            from and against any claims, actions or demands, liabilities and
            settlements including without limitation, reasonable legal and
            accounting fees, resulting from, or alleged to result from, your
            violation of these Agreement.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    21. Updates, Modifications &amp; Amendments
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    We may need to update, modify or amend our Merchant Terms of Service
                    as our technology evolves. We reserve the right to make changes to
                    this Merchant Terms of Service at any time by giving notice to users
                    on this page.
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                We advise that you check this page often, referring to the date of
            the last modification on the page If you have any objection to any
            of the changes to this Merchant Terms of Service, you must cease
            using our website and/or services immediately.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    22. Applicable Law
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    These Terms of Use shall be interpreted and governed by the laws
                    currently in force in the Federal Republic of Nigeria.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                23. Legal Disputes
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                We shall make an effort to settle all disputes amicably. Any dispute
            arising out of this Agreement which cannot be settled, by mutual
            agreement/negotiation within 1 (one) month shall be referred to
            arbitration by a single arbitrator at the Lagos Multi-Door
            Courthouse (&ldquo;LMDC&rdquo;) and governed by the Arbitration and
            Conciliation Act, Cap A10, Laws of the Federal Republic of Nigeria.
            The arbitrator shall be appointed by both of us (we and you), where
            both of us are unable to agree on the choice of an arbitrator, the
            choice of arbitration shall be referred to the LMDC. The findings of
            the arbitrator and subsequent award shall be binding on both of us.
            Each of us shall bear our respective costs in connection with the
            Arbitration. Venue for the arbitration shall be Lagos, Nigeria.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                    24. Severability
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                    If any portion of these Terms of Use is held by any court or
                    tribunal to be invalid or unenforceable, either in whole or in part,
                    then that part shall be severed from these Terms of Use and shall
                    not affect the validity or enforceability of any other part in this
                    Terms of Use.
                </div>
            </div>

            <div className='flex flex-col mt-5'>
                <div className='lg:text-[20px] ms:text-[16px] text-black font-medium'>
                25. Miscellaneous
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                You agree that all agreements, notices, disclosures and other
            communications that we provide to you electronically satisfy any
            legal requirement that such communications be in writing. Assigning
            or sub-contracting any of your rights or obligations under these
            Terms of Use to any third party is prohibited. We reserve the right
            to transfer, assign or sub-contract the benefit of the whole or part
            of any rights or obligations under these Terms of Use to any third
            party.
                </div>
                <div className='mt-[20px] lg:w-[18px] ms:w-[14px] lg:w-[70%] ms:w-[90%]'>
                Effective Date:&nbsp;Monday, January 1, 2024
                </div>
            </div>

        </div>
    );
}

export default Terms